import React, { useState } from "react";
import "../css/ModalPopUp.css";
import MasjidParigiSlider from "./slider/MasjidParigiSlider";
import Footer from "../../../../../../Footer";

export default function MasjidParigi() {

  return (
    <div className="modal-img">
        <MasjidParigiSlider/>
        <Footer/>
    </div>
  );
}